import { Routes, Route } from 'react-router-dom';
import { Layout } from './components';
import { LandingPage, ProjectDetailPage, AgentProfilePage, ExplorePage, NotFoundPage, TermsPage, PrivacyPage, HowItWorksPage } from './pages';

const App: React.FC = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/project/:id" element={<ProjectDetailPage />} />
        <Route path="/agents/:id" element={<AgentProfilePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
};

export default App;
